import { RootState } from 'store';

import type { ServiceContract } from '../Components/types';

const noConnectedServiceContracts: ServiceContract[] = [];

export const selectConnectedServiceContracts =
	(unitId: number) =>
	({ serviceContracts: { connectedByUnitId } }: RootState) =>
		connectedByUnitId[unitId] ?? noConnectedServiceContracts;
